import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const GetBuyerDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Buyer/GetDetail?` + params, null);

export const GetBuyerList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Buyer/GetList?` + params, null);

export const GetBuyerListForArea = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Buyer/GetListForArea?` + params, null);

export const GetBuyerListForReceipt = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Buyer/GetBuyerListForReceipt?` + params, null);

export const GetBuyerListForFieldSelect = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Buyer/GetBuyerListForFieldSelect?` + params, null);

export const CreateBuyer = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Buyer/Create`, data);

export const DeleteBuyer = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Buyer/Delete`, data);

export const UpdateBuyer = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Buyer/Update`, data);    

export const GetActiveBuyerByInvoiceDuration = (params: any) =>
  GET_ENC(
    `${BASE_URL}/api/ActiveBuyerByInvoiceDuration/GetActiveBuyerByInvoiceDuration?` +
      params,
    null
  );